// storeActions.js — DealCouponz pattern: thunks → storeServices
import * as types from "../types/storeTypes";
import * as storeServices from "../../services/storeServices";

export const fetchStores = () => async (dispatch) => {
  dispatch({ type: types.FETCH_STORES_REQUEST });
  try {
    const stores = await storeServices.getAllStores();
    dispatch({ type: types.FETCH_STORES_SUCCESS, payload: stores });
  } catch (error) {
    dispatch({
      type: types.FETCH_STORES_FAILURE,
      payload: error?.message || "Failed to load stores",
    });
  }
};

/** Store detail + coupons for slug + full store list (related). */
export const loadStorePage = (slug) => async (dispatch) => {
  dispatch({ type: types.LOAD_STORE_PAGE_REQUEST });
  try {
    const [store, storeCoupons, stores] = await Promise.all([
      storeServices.getStoreBySlug(slug),
      storeServices.getCouponsForStoreSlug(slug),
      storeServices.getAllStores(),
    ]);
    dispatch({
      type: types.LOAD_STORE_PAGE_SUCCESS,
      payload: {
        store,
        storeCoupons: store ? storeCoupons : [],
        stores,
      },
    });
  } catch (error) {
    dispatch({
      type: types.LOAD_STORE_PAGE_FAILURE,
      payload: error?.message || "Failed to load store",
    });
  }
};
